import axios from "axios";
import React, { useState, useEffect } from "react";
import { get_exist_customers } from "../../Pages/apis";

const CheckInModel = ({ room, setCustomer_info, customer_info, error }) => {
  const [customersList, setCustomersList] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  useEffect(() => {}, [customersList]);
  const handlechange = (e) => {
    const { name, value } = e.target;
    let number = "";
    if (name == "phone_number") {
      number = value;
    }
    setCustomer_info({
      ...customer_info,
      [name]: value,
    });
    if (customer_info.phone_number.length > 2) {
      const ph_number = customer_info.phone_number;
      axios
        .get(get_exist_customers + "/" + ph_number, { headers })
        .then((res) => {
          if (res?.data?.status === 200) {
            setCustomersList(res?.data?.customers);
            if (res?.data?.customers.length === 1) {
              const exist_number = res?.data?.customers[0]?.phone_number;
              if (number === exist_number) {
                setCustomer_info({
                  name: res?.data?.customers[0]?.name,
                  phone_number: exist_number,
                });
              }
              // if (res?.data?.customers.length === 2) {
              //   const exist_name = res?.data?.customers[1]?.name;
              //   if (name === exist_name) {
              //     setCustomer_info({
              //       phone_number: res?.data?.customers[1]?.phone_number,
              //       name: exist_name,
              //     });
              //   }
              // }
            }
          }
        });
    }
  };

  return (
    <div className="d-flex flex-column p-3">
      <input placeholder="Room Name" value={room} disabled />
      <input
        placeholder="Enter Your Name"
        value={customer_info?.name}
        name="name"
        type="text"
        onChange={handlechange}
      />
      <p className="text-danger">{error.error_name}</p>
      <input
        placeholder="Enter Phone Number"
        value={customer_info?.phone_number}
        name="phone_number"
        type="number"
        list="data"
        onChange={handlechange}
      />
      <datalist id="data">
        {customersList.map((item) => (
          <option key={item?.id} value={item?.phone_number} />
        ))}
      </datalist>
      <p className="text-danger">{error.error_phone}</p>
    </div>
  );
};

export default CheckInModel;
